import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {Row, Col} from "react-bootstrap"
import {FormattedMessage} from "@irati/utils/lang"
import Button, {DropzoneButton} from "@irati/ui/src/Button"
import Loading from "@irati/ui/src/Loading"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {H3} from "@irati/ui/src/Typography/Heading"
import {Hr} from "@irati/ui/src/Layout"

import Avatars from "./EditProfile/Avatars"
import Editor from "./EditProfile/Editor"

const ButtonCol = styled(Col)`
  ${Button}, ${DropzoneButton} {
    margin-bottom: ${padding.tiny};
  }
`

const ImageCol = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${minWidthMedia.tablet`
    align-items: flex-start;
  `}
`

const NextSteps = styled.div`
  display: flex;
  justify-content: space-between;
`

const LoadingContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  > .perkboxLoading_error {
    margin-bottom: 15px;
  }
`


class EditProfile extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectScreen: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      showAvatars: false,
      submit: null
    }
  }

  setImage = (image) => {
    this.editor.setImage(image)
  }

  handleDrop = (acceptedFiles) => {
    this.setImage(acceptedFiles[0])
  }

  toggleShowAvatars = () => {
    this.setState(({showAvatars}) => ({showAvatars: !showAvatars}))
  }

  handleRemove = () => this.setImage(null)

  handleSave = () => {
    const {onSubmit} = this.props
    const img = this.editor.getImage()

    const submit = onSubmit(img)
    this.setState({submit})
    return submit
  }

  handleCancel = () => this.props.selectScreen(null)

  render() {
    const {showAvatars, submit} = this.state
    const {user} = this.props

    return (
      <div>
        <H3><FormattedMessage id="account.editProfile.headerThree.profilePicture" /></H3>
        <Hr />
        <Row>
          <ImageCol xs={12} sm={6}>
            <Editor ref={(c) => { this.editor = c }} initialImage={user.profile_img} />
          </ImageCol>
          <ButtonCol xs={12} sm={6}>
            <DropzoneButton
              id="uploadNewImageButton"
              onDrop={this.handleDrop}>
              <FormattedMessage id="account.editProfile.dropZoneButton.text" />
            </DropzoneButton>
            <Button
              id="chooseAnAvatarButton"
              full
              onClick={this.toggleShowAvatars}>
              <FormattedMessage
                id="account.editProfile.button.hideChooseAvatars"
                values={{showAvatars}} />
            </Button>
            <Button
              id="removeImageButton"
              full
              onClick={this.handleRemove}>
              <FormattedMessage id="account.editProfile.button.removeImage" />
            </Button>
          </ButtonCol>
        </Row>
        {showAvatars &&
          <Row>
            <Col xs={12}>
              <Avatars onSelect={this.setImage} />
            </Col>
          </Row>
        }
        <LoadingContainer>
          <Loading load={submit} useLoader={false} />
        </LoadingContainer>
        <NextSteps>
          <Button
            id="resetProfilePictureButton"
            onClick={this.handleCancel}>
            <FormattedMessage id="account.editProfile.button.cancel" />
          </Button>
          <Button
            id="saveProfilePictureButton"
            primary
            onClick={this.handleSave}
            load={submit}>
            <FormattedMessage id="account.editProfile.button.save" />
          </Button>
        </NextSteps>
      </div>
    )
  }
}

export default EditProfile
